import axios from '../../utils/axios';

const baseUrl = `/api/changeLogs`;

export const fetchChangeLog = async (smProjectId: number) => {
  const requestUrl = `${baseUrl}/smProject/${smProjectId}`;
  return await axios.get(requestUrl);
};
